import {
  Box,
  BoxProps,
  FormControl,
  InputLabel,
  useTheme,
} from '@mui/material';

type PropsType = BoxProps & {
  label?: string;
};

export const FieldSetWrapper = (props: PropsType) => {
  const { children, label, ...boxProps } = props;

  const theme = useTheme();

  return (
    <Box
      {...boxProps}
      sx={{
        padding: theme.spacing(0.875),
        margin: theme.spacing(-0.875),
        borderRadius: theme.spacing(1.5),
        backgroundColor: '#fafafa',
        '& .MuiInputBase-root': {
          backgroundColor: theme.palette.background.default,
        },
      }}
    >
      {!!label && (
        <FormControl sx={{ marginBottom: theme.spacing(2.5), width: '100%' }}>
          <InputLabel sx={{ color: theme.palette.text.primary }} shrink={true}>
            {label}
          </InputLabel>
        </FormControl>
      )}
      {children}
    </Box>
  );
};
